// Toujours en premier : dans le simulateur de la console, l'app range ses clés en mémoire
// avant que quoi que ce soit ne lise le stockage du navigateur.
import { enSimulation } from "@/lib/simulation";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Le service worker rend le site installable sur l'écran d'accueil et le fait s'ouvrir
// même sans réseau. Il n'est enregistré qu'une fois la page affichée, pour ne rien
// ralentir, et jamais en développement local (il masquerait les changements de code).
// Le simulateur de la console (un cadre dans la console) n'en enregistre pas.
if ("serviceWorker" in navigator && window.location.hostname !== "localhost" && !enSimulation()) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
